module.exports = __webpack_public_path__ + "img/symbol_9.621969c4.png";